import history from '../history/index';
import ReactGA from 'react-ga';

const analytics = {
  page: pathname => {
    ReactGA.set({page: pathname});
    ReactGA.pageview(pathname);
  },
  identify: userId => {
    try {
      ReactGA.set({userId});
      window.Sentry.configureScope(function(scope) {
        scope.setUser({id: userId});
      });
    } catch (error) {
      console.error(error);
    }
  },
  reset: (...args) => {
    // TODO: reset user IDs for GA/Sentry
  },
  trackHistory() {
    analytics.page(window.location.pathname);
    history.listen((location, action) => {
      analytics.page(location.pathname);
    });
  },
};

if (process.env.NODE_ENV === 'production') {
  try
  {
    window.Sentry.init({
        dsn: 'https://c2120e5598f540bcb0fa6d676a791de8@sentry.io/1674719',
      });

      const trackingId = 'UA-35815154-2';
      ReactGA.initialize(trackingId);
  }
  catch{}
} else {
  Object.keys(analytics).forEach(key => {
    analytics[key] = (...args) => {
      console.info(key, ...args);
    };
  });
}

export default analytics;
